import React, { useContext, useRef, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Link } from 'react-router-dom';
import logo from '../../logo.png';

const DocTree = ({ formFields, docName, parent }: any) => {
    const [isCollapsed, setIsCollapsed] = useState(true);


    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    // These classes control the width of the sidebar.
    const sidebarClass = isCollapsed ? 'w-4' : 'w-56'; // Adjust the width to your design.

    return (
        formFields && formFields.length > 0 ? (
            <div className={`bg-gray-50 ${parent ? "border-r" : ''} max-h-[calc(100vh-1px)] scrollbar-hidden`}>
            <div className={`flex flex-row bg-gray-50 h-full`}>
                <div className={`flex flex-col ${parent ? sidebarClass : ""} bg-gray-50 relative transition-all duration-20`}>
                    {parent && (
                        <div className={`absolute top-5 -right-3 z-60 transform cursor-pointer rounded-full border`} onClick={toggleSidebar}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="black" className={`w-6 h-6 transform ${isCollapsed ? 'rotate-180' : ''} transition-transform bg-white rounded-full shadow-md p-2`}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                            </svg>
                        </div>
                    )}
                    {!isCollapsed && (
                        <div className="flex flex-col px-4 py-2 overflow-y-auto">
                            {parent && (
                                <div className="flex items-center justify-center mt-8 mb-2">
                                    <h1 className="uppercase text-gray-500 font-medium">{docName}</h1>
                                </div>
                            )}
                            {formFields.map((field: any) => {
                                if (field.type) {
                                    return (
                                        <div key={field.name} className="pt-2">
                                            <a href="#" className="flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 text-gray-500 hover:text-gray-800">
                                                <span className="inline-flex items-center justify-center h-12 w-12 text-lg text-gray-400"></span>
                                                <span className="text-sm font-light uppercase">{field.name}</span>
                                            </a>
                                            {field.type === 'array' || field.type === 'object' ? (
                                                <div className="ml-2">
                                                    <DocTree formFields={field.schema} docName={field.name} parent={false} />
                                                </div>
                                            ) : null}
                                        </div>
                                    );
                                }
                                // Return null or some other element for non-array fields if necessary
                                return null;
                            })}
                        </div>
                    )}
                </div>
            </div>
            </div>
        ) : null
    );
};

export default DocTree;